import React from 'react';
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { closeDrawer } from "../../actions/drawerActions";
import ArgoAppBarHook from "../common/ArgoAppBarHook";
import IntegrationEditorHook from "../qd/integrations/IntegrationEditorHook";
import { createIntegrationAndCloseDrawer, updateIntegrationAndCloseDrawer } from "../../actions/integrationActions";
import * as TEMPLATE from "../../constants/templateConstants";


function IntegrationCreateEditDrawerHook(props) {
    const dispatch = useDispatch();
    const filter = useSelector(state => state.filter[TEMPLATE.FILTER.all.integration] || {});

    const handleCloseDrawer = () => {
        dispatch(closeDrawer());
    };

    const handleRequestSave = (integration) => {
        if (typeof props.setLoadingState === "function") {
            props.setLoadingState(save, integration);
        } else {
            save(integration);
        }
    };

    const save = async (integration) => {
        if (props.createMode) {
            dispatch(createIntegrationAndCloseDrawer(integration, filter));
        } else {
            await dispatch(updateIntegrationAndCloseDrawer(
                integration, 
                filter.title, 
                filter.updated, 
                filter.integrationType,
                filter.pageNumber, 
                filter.pageSize,
                filter.name, 
                filter.direction
            ));
        }
    };

    return (
        <div style={{ height: "100%" }}>
            <ArgoAppBarHook
                title={props.createMode ? "Create Integration" : "Edit Integration"}
                showMenuIconButton={false}
                noIcon={true}
                isDrawer={true}
                width={integrationCreateEditDrawerProps.width}
            />

            <div style={{ height: '64px' }}></div>

            <IntegrationEditorHook
                save={handleRequestSave}
                cancel={handleCloseDrawer}
                id={props.id}
                width={integrationCreateEditDrawerProps.width}
            />
        </div>
    );
}

IntegrationCreateEditDrawerHook.defaultProps = {
    id: "",
    createMode: false
};

IntegrationCreateEditDrawerHook.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    saveIntrgration: PropTypes.func,
    filter: PropTypes.object,
    createMode: PropTypes.bool,
    setLoadingState: PropTypes.func,
};

const integrationCreateEditDrawerProps = {
    opensecondary: true,
    width: "50%",
    docked: false,
    anchor: "right"
};

export default IntegrationCreateEditDrawerHook;
export { integrationCreateEditDrawerProps };